import React, { useState, useEffect } from 'react';

const DownloadModal = ({ isDownloadModalOpen, setIsDownloadModalOpen }) => {
    const [status, setStatus] = useState('idle'); // idle, sending, success

    useEffect(() => {
        if (!isDownloadModalOpen) return;

        const interval = setInterval(() => {
            const localStatus = localStorage.getItem('status') || 'idle';
            setStatus(localStatus);
        }, 1000);

        return () => clearInterval(interval);
    }, [isDownloadModalOpen]);

    const handleClose = () => {
        setIsDownloadModalOpen(false);
        localStorage.setItem('status', 'idle');
        setStatus('idle');
    };

    return (
        <>
            {isDownloadModalOpen && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        background: '#fff', padding: '30px', borderRadius: '8px', width: '400px', maxWidth: '90%',
                        boxShadow: '0 5px 15px rgba(0,0,0,0.3)', position: 'relative'
                    }}>
                        <button
                            onClick={handleClose}
                            style={{ position: 'absolute', top: '10px', right: '15px', background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' }}
                        >
                            &times;
                        </button>

                        <h3>Download Pattern</h3>

                        {status === 'idle' && (
                            <>
                                <div style={{ marginTop: '20px' }}>
                                    <label htmlFor="email" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Email Address:</label>
                                    <input
                                        type="email"
                                        id="email"
                                        placeholder="Enter your email"
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            border: '1px solid #ccc',
                                            borderRadius: '5px',
                                            boxSizing: 'border-box'
                                        }}
                                    />
                                </div>
                                <button
                                    onClick={() => {
                                        const email = document.getElementById('email').value;
                                        if (!email) {
                                            alert("Please enter a valid email address!");
                                            return;
                                        }
                                        localStorage.setItem('status', 'sending');
                                        localStorage.setItem('email', email);
                                    }}
                                    style={{
                                        marginTop: '20px', width: '100%', padding: '10px',
                                        backgroundColor: '#28a745', color: 'white', fontWeight: 'bold',
                                        border: 'none', borderRadius: '5px', cursor: 'pointer'
                                    }}
                                >
                                    Download PDF
                                </button>
                            </>
                        )}

                        {status === 'sending' && (
                            <div style={{ marginTop: '20px', textAlign: 'center' }}>
                                <div className="spinner" style={{
                                    width: '50px', height: '50px', border: '6px solid #f3f3f3',
                                    borderTop: '6px solid #28a745', borderRadius: '50%',
                                    animation: 'spin 1s linear infinite', margin: 'auto'
                                }} />
                                <p style={{ marginTop: '15px' }}>Sending your pattern...</p>
                            </div>
                        )}

                        {status === 'sent' && (
                            <div style={{ marginTop: '20px', textAlign: 'center' }}>
                                <div style={{
                                    width: '60px', height: '60px', borderRadius: '50%',
                                    backgroundColor: '#28a745', display: 'flex', alignItems: 'center',
                                    justifyContent: 'center', fontSize: '30px', color: 'white', margin: 'auto'
                                }}>
                                    ✓
                                </div>
                                <p style={{ marginTop: '15px', color: '#28a745', fontWeight: 'bold' }}>
                                    Pattern sent successfully!
                                </p>
                                <button
                                    onClick={handleClose}
                                    style={{
                                        marginTop: '20px', padding: '10px 20px',
                                        backgroundColor: '#28a745', color: 'white', fontWeight: 'bold',
                                        border: 'none', borderRadius: '5px', cursor: 'pointer'
                                    }}
                                >
                                    Close
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default DownloadModal;
